/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Days_Per_Week_QuestionInputs */

const en_us2_onboarding_days_per_week_question = /** @type {(inputs: Onboarding_Days_Per_Week_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many days a week can you train?`)
};

const pt_br2_onboarding_days_per_week_question = /** @type {(inputs: Onboarding_Days_Per_Week_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos dias por semana você pode treinar?`)
};

const es_419_onboarding_days_per_week_question = /** @type {(inputs: Onboarding_Days_Per_Week_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos días por semana puedes entrenar?`)
};

const pt_pt2_onboarding_days_per_week_question = /** @type {(inputs: Onboarding_Days_Per_Week_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos dias por semana podes treinar?`)
};

const fr_fr2_onboarding_days_per_week_question = /** @type {(inputs: Onboarding_Days_Per_Week_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de jours par semaine peux-tu t'entraîner ?`)
};

const de_de2_onboarding_days_per_week_question = /** @type {(inputs: Onboarding_Days_Per_Week_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An wie vielen Tagen pro Woche kannst du trainieren?`)
};

const it_it2_onboarding_days_per_week_question = /** @type {(inputs: Onboarding_Days_Per_Week_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti giorni a settimana puoi allenarti?`)
};

/**
* | output |
* | --- |
* | "How many days a week can you train?" |
*
* @param {Onboarding_Days_Per_Week_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_days_per_week_question = /** @type {((inputs?: Onboarding_Days_Per_Week_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Days_Per_Week_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_days_per_week_question(inputs)
	if (locale === "es-419") return es_419_onboarding_days_per_week_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_days_per_week_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_days_per_week_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_days_per_week_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_days_per_week_question(inputs)
	return en_us2_onboarding_days_per_week_question(inputs)
});
export { onboarding_days_per_week_question as "onboarding.days_per_week.question" }